














































































































import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import BrandMixin from "@/mixins/brandMixin";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { IState } from "@/store";
import priceListsFilters from "@/data/filters/priceLists";
import priceListsSorters from "@/data/sorters/priceLists";
import { IPricelist } from "@/models/products";

@Component({
  computed: {
    ...mapState({
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`]();
      }
    })
  }
})
export default class PriceListsTable extends Mixins(
  FilteringSortingTableStore,
  BrandMixin
) {
  // Getters
  public params!: object;

  // Variables
  public filters: IFilter[] = priceListsFilters;

  public sorters: ISorter[] = priceListsSorters;

  public dataModule: string = DataModules.PRICELISTS;

  public created() {
    if (this.contentAvailable) {
      this.getData();
    }
  }

  public async openDeletePricelistConfirmation(pricelistId: IPricelist["id"]) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.price_list") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            this.table.loading = true;
            try {
              await this.deletePriceList(pricelistId);
              await this.refreshList();

              this.$buefy.toast.open({
                message: this.$t("_.object_successfully_removed", {
                  object: this.$t("_.price_list")
                }) as string
              });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            }

            this.table.loading = false;
            confirm.close();
          }
        }
      }
    });
  }

  public deletePriceList(pricelistId: IPricelist["id"]): Promise<any> {
    return this.$store.dispatch(`data/${this.dataModule}/remove`, {
      id: pricelistId
    });
  }

  public async openAddEditPricelistModal(priceListId: IPricelist["id"]) {
    if (
      priceListId
        ? this.$userCan(`create_pricelist`)
        : this.$userCan(`update_pricelist`)
    ) {
      this.$store.dispatch(
        `data/${this.dataModule}/openAddEditPriceListModal`,
        {
          props: { priceListId },
          events: {
            success: () => this.refreshList()
          }
        }
      );
    }
  }

  public refreshList() {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      params: this.params,
      scope: this.dataScope,
      ignoreStored: true,
      vm: this
    });
  }

  public get contentAvailable() {
    return this.$userCan("list_pricelists");
  }
}
